import { ref, onMounted } from "vue";





import { u as useEvent } from "./useEvent.js";
import { u as useHTMLElement } from "./useHTMLElement.js";

function usePressed(el) {
  const isPressed = ref(false);
  const onMouseDown = () => {
    isPressed.value = true;
  };
  const onMouseUp = () => {
    isPressed.value = false;
  };
  onMounted(() => {
    if (!(el == null ? void 0 : el.value)) {
      return;
    }
    const getTarget = useHTMLElement(el);
    useEvent("mousedown", onMouseDown, getTarget);
    useEvent(["mouseup", "mouseleave"], onMouseUp, getTarget);
  });
  return { isPressed, onMouseDown, onMouseUp };
}
export { usePressed as u };
//# sourceMappingURL=usePressed.js.map
